export default "__VITE_ASSET__cBLo2$te__"